import * as Sentry from "@sentry/nextjs";

export function logError(
  error: unknown,
  context: {
    feature?: string;
    action?: string;
    userId?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    extra?: Record<string, any>;
  } = {},
) {
  if (process.env.VERCEL_ENV === "development") {
    console.error(
      `[${context.feature || "unknown"} / ${context.action || "unknown"}]`,
      error,
      context.extra,
    );
    return; // ← Don't send to Sentry in dev
  }
  if (process.env.VERCEL_ENV === "production") {
    Sentry.captureException(error, {
      tags: {
        feature: context.feature || "unknown",
        action: context.action || "unknown",
      },
      extra: {
        userId: context.userId,
        ...(context.extra || {}),
        // Automatically add more useful info
        errorMessage: error instanceof Error ? error.message : String(error),
        errorName: error instanceof Error ? error.name : undefined,
        // isAxiosError: axios.isAxiosError(error),
      },
    });
  }
}
